import {NavItem} from '@interfaces/nav-item';


// Field technician: in the panel he only needs his QR, to enter from the headset or the phone (spec of 03/11/2026)
export const navItemsTechnician: NavItem[] = [
  {
    displayName: 'menu.my_qrcode',
    iconName: 'solar:qr-code-linear',
    route: '/users/qrcode',
  },
];
